import axiosHandler from "./axios-handler";

export default async function sendFeedback(data, id, isCourse, isLearningPath) {
  let url;
  if (isLearningPath) {
    url = `${process.env.NEXT_PUBLIC_BASE_URL}/v1/learning-path/entry/${id}/feedback`;
  } else if (isCourse) {
    url = `${process.env.NEXT_PUBLIC_BASE_URL}/v1/course/entry/${id}/feedback`;
  } else {
    url = `${process.env.NEXT_PUBLIC_BASE_URL}/v1/lesson/entry/${id}/feedback`;
  }

  const options = {
    method: "POST",
    data: {
      ...data,
    },
    url,
    withCredentials: true,
  };

  const response = await axiosHandler(options);
  if (response?.response?.status === 200) {
    alert("Feedback submitted!");
  }
  return response;
}
